export interface WatchList {
  id: number;
  name: string;
  symbols: string[];
}

export interface Chart {
  id: number;
  name: string;
}

export interface UserSettings {
  userCredentialsSet: boolean;
  adminCredentialsSet: boolean;
  isActive: boolean;
  selectedChartId: number | null;
  selectedChartName: string | null;
  selectedWatchListId: number | null;
  selectedWatchListName: string | null;
  indicatorTitle?: string | null;
  selectedWatchListTickers?: string[] | null;
  watchLists?: WatchList[];
  charts?: Chart[];
}

export interface ConnectCredentialsRequest {
  userSessionId: string;
  userSessionIdSign: string;
}

export interface ConnectCredentialsResponse {
  watchLists: WatchList[];
  charts: Chart[];
  message: string;
}

export interface SaveSettingsRequest {
  watchListId: number;
  chartId: number;
  indicatorTitle: string;
  symbols?: string[];
}

export interface SymbolSelection {
  symbol: string;
  selected: boolean;
}

export interface PublishSchedule {
  hasSchedule?: boolean;
  isEnabled: boolean;
  daysOfWeek: string[];
  timeOfDay: string;
  timeZoneId: string;
  nextRunAtUtc?: string | null;
  lastRunAtUtc?: string | null;
  lastSuccessAtUtc?: string | null;
  lastFailureAtUtc?: string | null;
  lastStatus?: string | null;
  lastMessage?: string | null;
}

export interface SavePublishScheduleRequest {
  isEnabled: boolean;
  daysOfWeek: string[];
  timeOfDay: string;
  timeZoneId: string;
}

export interface TimeZoneOption {
  label: string;
  id: string;
}

export const SCHEDULE_TIME_ZONES: TimeZoneOption[] = [
  { label: 'Eastern Time (ET)', id: 'America/New_York' },
  { label: 'Central Time (CT)', id: 'America/Chicago' },
  { label: 'Mountain Time (MT)', id: 'America/Denver' },
  { label: 'Pacific Time (PT)', id: 'America/Los_Angeles' },
];

const SCHEDULE_TIME_ZONE_ALIASES: Record<string, string> = {
  'America/Phoenix': 'America/Denver',
  'America/Anchorage': 'America/Los_Angeles',
  'Pacific/Honolulu': 'America/Los_Angeles',
  'UTC': 'America/New_York',
  'US/Eastern': 'America/New_York',
  'US/Central': 'America/Chicago',
  'US/Mountain': 'America/Denver',
  'US/Pacific': 'America/Los_Angeles',
};

export function normalizeScheduleTimeZoneId(timeZoneId?: string | null): string {
  const supportedIds = SCHEDULE_TIME_ZONES.map(zone => zone.id);

  if (timeZoneId && supportedIds.includes(timeZoneId)) {
    return timeZoneId;
  }

  if (timeZoneId && SCHEDULE_TIME_ZONE_ALIASES[timeZoneId]) {
    return SCHEDULE_TIME_ZONE_ALIASES[timeZoneId];
  }

  return 'America/New_York';
}
